var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5822 6.94511C13.1291 6.71433 13.5135 6.16821 13.5135 5.53125C13.5135 4.68556 12.8359 4 12 4C11.1641 4 10.4865 4.68556 10.4865 5.53125C10.4865 6.16821 10.8709 6.71433 11.4178 6.94511C10.0422 8.38498 9.22724 10.4728 8.97297 11.4375C7.76216 9.51251 5.15315 9.32293 4 9.46876C5.55676 11.7438 5.87387 14.3542 5.72973 15.375H12H18.2703C18.1261 14.3542 18.4432 11.7438 20 9.46876C18.8468 9.32293 16.2378 9.51251 15.027 11.4375C14.7728 10.4728 13.9578 8.38499 12.5822 6.94511ZM5.72974 16.25H18.2703V17C18.2703 17.5523 17.8226 18 17.2703 18H6.72974C6.17745 18 5.72974 17.5523 5.72974 17V16.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.548e345e.svg";
export { ForwardRef as ReactComponent };